module.exports = __webpack_public_path__ + "img/member_team.78d59cf7.png";